export type MessengerKind = 'eitaa' | 'rubika' | 'bale' | 'telegram' | 'instagram' | 'linkedin'

export function MessengerIcon({ kind }: { kind: MessengerKind }) {
  if (kind === 'eitaa' || kind === 'rubika' || kind === 'bale') {
    const extension = kind === 'bale' ? 'ico' : kind === 'eitaa' ? 'svg' : 'png'
    return <img src={`/images/social/${kind}.${extension}`} alt="" aria-hidden="true" />
  }
  if (kind === 'linkedin') {
    return (
      <svg viewBox="0 0 32 32" fill="currentColor" aria-hidden="true" focusable="false">
        <path d="M8.34 12.46h4.12V25H8.34V12.46Zm2.06-6.23a2.39 2.39 0 1 1 0 4.78 2.39 2.39 0 0 1 0-4.78ZM15.11 12.46h3.95v1.71h.06c.55-1.04 1.9-2.14 3.91-2.14 4.18 0 4.95 2.75 4.95 6.33V25h-4.12v-5.89c0-1.41-.03-3.22-1.96-3.22-1.97 0-2.27 1.53-2.27 3.12V25h-4.12l-.4-12.54Z" />
      </svg>
    )
  }
  if (kind === 'instagram') {
    return (
      <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden="true">
        <rect x="4" y="4" width="24" height="24" rx="7" />
        <circle cx="16" cy="16" r="5.5" />
        <circle cx="23.2" cy="8.8" r="1.4" fill="currentColor" stroke="none" />
      </svg>
    )
  }
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true">
      <path d="M27.7 5.1 23.4 27c-.3 1.2-1.2 1.5-2.2.9l-6.1-4.5-3.2 3.1c-.3.3-.7.6-1.3.6l.5-6.4L22.6 10c.5-.4-.1-.7-.6-.4L8.2 19.5l-5.4-1.8c-1.2-.4-1.2-1.3.3-1.8L25.6 4c1.4-.5 2.4.2 2.1 1.1Z" fill="currentColor" />
    </svg>
  )
}
